import ModalRegular from './modal-regular';

export default ModalRegular;
